module.exports = __webpack_public_path__ + "img/mobile_banner_memberMarking.3b84f2ff.png";